module.exports = __webpack_public_path__ + "876c6196eb29e2c1ed8350c243cf2081.png";